import { useEffect, useState } from "react";

function hexToRgb(hex) {
  hex = hex.startsWith("#") ? hex : `#${hex}`;
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function luminance(r, g, b) {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function useColorSimilarity(color1, color2, threshold = 1.5) {
  const [isSimilar, setIsSimilar] = useState(false);

  useEffect(() => {
    const rgb1 = hexToRgb(color1);
    const rgb2 = hexToRgb(color2);

    if (rgb1 && rgb2) {
      const lum1 = luminance(rgb1.r, rgb1.g, rgb1.b);
      const lum2 = luminance(rgb2.r, rgb2.g, rgb2.b);
      const contrastRatio =
        (Math.max(lum1, lum2) + 0.05) / (Math.min(lum1, lum2) + 0.05);

      setIsSimilar(contrastRatio < threshold);
    } else {
      setIsSimilar(false);
    }
  }, [color1, color2, threshold]);

  return isSimilar;
}

export default useColorSimilarity;
